export function ContactMailLink({ email, className = "text-[#00BF0D] hover:underline", children }) {
    const label = children ?? email;
    return (
        <a href={`mailto:${email}`} className={className}>
            {label}
        </a>
    );
}
